import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import '../../../pages/client/client_assets/css/common.css';

import config from '../../../config/config.js';


function Tags() {
  const [category, setCategory] = useState('');
  const [categories, setCategories] = useState([]);  // State to store categories
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [editCategoryId, setEditCategoryId] = useState(null);
  // Fetch categories from the backend when the component mounts
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${config.API_BASE_URL}/get_tags.php`);
        const data = await response.json();
        if (data.success) {
          setCategories(data.categories);  // Assuming data contains the categories array
        } else {
          //toast.error(data.message || 'Failed to fetch tags.');
        }
      } catch (error) {
        //.error('An error occurred while fetching tags.');
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  // Handle the category input change
  const handleCategoryChange = (event) => {
    setCategory(event.target.value);
  };

  // Handle category submission
  const handleSubmit = async () => {
    if (!category.trim()) {
      toast.error('Please enter a valid tag.');
      return;
    }

    try {
      const response = await fetch(`${config.API_BASE_URL}/tags.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name: category }),
      });

      const data = await response.json();

      if (data.success) {
        toast.success(`Tag "${category}" submitted successfully!`);
        setCategories((prevCategories) => [
          ...prevCategories,
          { name: category, created_at: new Date().toISOString() }, // Add new category to the list
        ]);
        setCategory(''); // Clear the input after successful submission
      } else {
        toast.error(data.message || 'Failed to submit tag.');
      }
    } catch (error) {
      toast.error('An error occurred while submitting the tag.');
    }
  };

  const handleEdit = (category) => {
    setIsEditing(true);
    setEditCategoryId(category.id);
    setCategory(category.name);
    
  };
  return (
    <>
      <div className="container-fluid">
        <div className="category_input_wrapper mt-5">
          <div className="mb-3" style={{ width: '33%' }}>
            <h1 className=" dashboard_heading">Create Tag</h1>
            <input
              type="text"
              id="categoryInput"
              className="form-control"
              placeholder="Enter Tag Name"
              value={category}
              onChange={handleCategoryChange}
            />
          </div>
        </div>

        <Button onClick={handleSubmit} className="exportbutton"> {`${isEditing ? "Update" : "Create"}` } </Button>
      </div>

      <div id="configtable" className="w-100 table-container ">
        {loading ? (
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Tag Name</th>
                <th>Created At</th>
                <th>Actions</th>

              </tr>
            </thead>
            <tbody>
              {categories.length > 0 ? (
                categories.map((category, index) => {
                  const formattedDate = new Date(category.created_at).toLocaleDateString();
                  return (
                    <tr key={category.id || index}>
                      <td>{category.name}</td>
                      <td>{formattedDate}</td>
                      <td>
                        <div className='action_btn'>
                          <div className='' style={{marginRight:"20px", color:"#0d6efd"}} onClick={()=>handleEdit(category)}>Edit</div>
                          <div className='' style={{color:"#dc3545"}} >Delete</div>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="2">No tags available</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      <ToastContainer />
    </>
  );
}

export default Tags;
